import React from 'react';
import AppListHome from '../../../components/ui/AppListHome';
import usePostHome from '../../../hooks/usePostHome';

const SearchDashboard: React.FC = () => {
    const {dashboardQuery}=usePostHome('search')
     return (
    <div className="search-dashboard text-center">
 
        {dashboardQuery?.data?.modules && <AppListHome data={dashboardQuery?.data?.modules} />}
      </div>
    
  );
};

export default SearchDashboard;
